import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onMounted, onUnmounted, ref} from "vue";
import StoryPopup from "@/ts/Story/StoryPopup";


export default /*@__PURE__*/_defineComponent({
  __name: 'StoryPopup',
  props: {
    activeUntilOffset: {}
  },
  emits: ['close'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const show = ref(true);
const hide = () => {
  show.value = false;
  popup.destroy()
  emit('close')
}
const onBack = () => {
  hide()
}
const emit = __emit
__expose({
  hide
})
const container = ref<HTMLElement>()
const popup = new StoryPopup(100, props.activeUntilOffset)
popup.onClose(() => {
  hide()
})
onMounted(() => {
  popup.init(container.value!)
})
onUnmounted(() => {
  popup.destroy()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["popup-container", {show: show.value}])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["popup", {show: show.value}]),
      ref_key: "container",
      ref: container
    }, [
      _renderSlot(_ctx.$slots, "default", { hide: hide })
    ], 2),
    _createElementVNode("div", {
      class: "popup-overlay",
      onClick: onBack
    })
  ], 2))
}
}

})